import React, { FC, useState } from 'react';
import { Button } from 'src/components/Button/Button';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import { MuscleGroupImages } from '../assets/MuscleGroupImages';
import { resolveBodyProfile } from 'src/utils/genderUtils';
import './IncreaseStrengthSteps.scss';

interface WeightLossStep1Props {
  value?: string;
  clientBodyProfile?: string;
  onNext?: (value: string) => void;
}

// What is the main area this program should prioritize?
export const WeightLossStep1: FC<WeightLossStep1Props> = ({
  value,
  clientBodyProfile = 'Male',
  onNext,
}) => {
  const [selectedFocus, setSelectedFocus] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const genderKey = resolveBodyProfile(clientBodyProfile);
  const images = MuscleGroupImages[genderKey] || MuscleGroupImages.male;

  const iconMap: Record<string, string> = {
    full_body: images.full_body,
    upper_body: images.upper_body,
    lower_body: images.lower_body,
    core: images.core,
    back: images.back,
    glutes: images.glutes,
  };

  const groupData = programMasterData?.trainingGoalDetails?.groups?.find(
    (g: any) => g.goalId === 'weight_loss',
  );

  const focusPrograms = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  const toggleFocusProgram = (programSlug: string) => {
    setSelectedFocus(programSlug);
    if (onNext) onNext(programSlug);
  };

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>

      <div
        className="program-focus-container trainer-program-focus-wrapper max-width-576"
        style={{ margin: '0 auto' }}
      >
        <div className="trainer-program-focus-button-wrapper">
          <div className="trainer-program-focus-flex-button">
            {focusPrograms.map((program: any) => (
              <Button
                key={program.id}
                onClick={() => toggleFocusProgram(program.slug)}
                variant="primary"
                className={`${selectedFocus === program.slug ? 'active' : ''} program-focus-program-button justify-content-center`}
              >
                {program.title}
              </Button>
            ))}
          </div>
        </div>
        <div className="trainer-program-focus-image-wrapper">
          <img src={images.base} className="muscle-group" alt={'muscleGroup'} />
          {focusPrograms.map((program: any) => {
            const imgSrc = iconMap[program.id];
            if (!imgSrc) return null;
            return (
              <img
                key={program.id}
                src={imgSrc}
                className={`${selectedFocus === program.slug ? 'active' : ''} muscle-group-item`}
                alt={program.id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
